import { AzureUser } from "@app-models/azure-user";
import { KeyVal } from '@app-models/common';

export enum REQUEST_STATUS {
    'Draft' = 1,
    'Submitted',
    'Internal Review',
    'In Progress',
    'Closed',
}


export class GlobalConstants {

    public static siteTitle = "SO - Work Request Form";



    public static noLoggedInUser: AzureUser = {
        id: "0",
        mail: "",
        userPrincipalName: "",
        manager: {
            id: "0",
            mail: "",
            userPrincipalName: ""
        }

    }
    /*
    public static months: KeyVal[] = [
        { 'key': 0, 'value': 'January' },
        { 'key': 1, 'value': 'February' },
        { 'key': 2, 'value': 'March' },
        { 'key': 3, 'value': 'April' },
        { 'key': 4, 'value': 'May' },
        { 'key': 5, 'value': 'June' },
        { 'key': 6, 'value': 'July' },
        { 'key': 7, 'value': 'August' },
        { 'key': 8, 'value': 'September' },
        { 'key': 9, 'value': 'October' },
        { 'key': 10, 'value': 'November' },
        { 'key': 11, 'value': 'December' }
    ]
    */


    public static ADMIN_DATA_STORED_KEY = 'ADMIN_QUERY_DATA';
    //the mode of these values need to match the last path elements ex: /time-entry-view/manager

    public static STATUS_DRAFT = 'Draft';
    public static STATUS_SUBMITTED = 'Submitted';
    public static STATUS_INTERNAL_REVIEW = 'Internal Review';
    public static STATUS_IN_PROGRESS = 'In Progress';
    public static STATUS_CLOSED = 'Closed';

    public static statusValues: KeyVal[] = [
        { 'key': this.STATUS_DRAFT, 'value': this.STATUS_DRAFT},
        { 'key': this.STATUS_SUBMITTED, 'value': this.STATUS_SUBMITTED },
        { 'key': this.STATUS_INTERNAL_REVIEW, 'value': this.STATUS_INTERNAL_REVIEW },
        { 'key': this.STATUS_IN_PROGRESS, 'value': this.STATUS_IN_PROGRESS },
        { 'key': this.STATUS_CLOSED, 'value': this.STATUS_CLOSED }
    ]

    public static consultationTypeValues: KeyVal[] = [
        { key: "Technical", value: "Technical Consultation" },
        { key: "Privacy Legislative", value: "Privacy Legislative ( FOI, Training, Privacy Breach)" },
        { key: "Privacy Technical", value: "Privacy Technical (PIA, RKAP, Requirements)" },
    ];

    public static projectStatuses = [
        { key: 'on-plan', value: 'On Plan', short: "G" },
        { key: 'behind-plan', value: 'Behind Plan', short: "Y" },
        { key: 'significantly-behind-plan', value: 'Significantly Behind Plan', short: "R" },
        { key: 'completed', value: 'Completed', short: "C" },
        { key: 'not-started', value: 'Not Started', short: "N" },
        { key: 'pre-planning', value: 'Pre-planning / Pilot', short: "P" }
    ]

 
    public static projectStatusObj : { [index: string]: any }   = {
        'on-plan' : this.projectStatuses[0],
        'behind-plan' : this.projectStatuses[1],
        'significantly-behind-plan' : this.projectStatuses[2],
        'completed' : this.projectStatuses[3],
        'not-started' : this.projectStatuses[4],
        'pre-planning' : this.projectStatuses[5],

    }
    public static nonProjectCheckpoints = [
        { key: 'Queued', value: 'Queued', short: "Q" },
        { key: 'In-Progress Assessing', value: 'In-Progress Assessing', short: "A" },
        { key: 'Fulfillment', value: 'Fulfillment', short: "F" },
        { key: 'Closed', value: 'Closed', short: "C" },
        { key: 'Cancelled', value: 'Cancelled', short: "X" }
    ]

    public static REQUEST_TYPE_PROJECT = 'Project';
    public static REQUEST_TYPE_PROJECT_VALUE = 'Project';
    
    public static REQUEST_TYPE_CONSULTATION = 'Consultation';
    public static REQUEST_TYPE_CONSULTATION_VALUE = 'Consultation/Queries';
    
    public static REQUEST_TYPE_WORK_ORDER = 'Work Order';
    public static REQUEST_TYPE_WORK_ORDER_VALUE = 'Work Order';
    
    
    public static requestTypeValues: KeyVal[] = [
        { 'key': this.REQUEST_TYPE_PROJECT, 'value': this.REQUEST_TYPE_PROJECT_VALUE },
        { 'key': this.REQUEST_TYPE_CONSULTATION, 'value': this.REQUEST_TYPE_CONSULTATION_VALUE },
        { 'key': this.REQUEST_TYPE_WORK_ORDER, 'value': this.REQUEST_TYPE_WORK_ORDER_VALUE },
    ];

    public static PROJECT_TYPE_OTHER = 'Other';
    public static PROJECT_TYPE_PRIORITY_INITIATIVES = 'Priority Initiatives';
    public static PROJECT_TYPE_OPERATIONS = 'Operations';
    public static projectTypes: KeyVal[] = [
        { key: this.PROJECT_TYPE_PRIORITY_INITIATIVES, value: this.PROJECT_TYPE_PRIORITY_INITIATIVES },                     
        { key: this.PROJECT_TYPE_OPERATIONS, value: this.PROJECT_TYPE_OPERATIONS }
    ];



    public static requestTypes = [this.REQUEST_TYPE_PROJECT, this.REQUEST_TYPE_CONSULTATION, this.REQUEST_TYPE_WORK_ORDER];

    //public static REQUEST_FORM_MODE_STD = "std";
    public static REQUEST_FORM_MODE_USER = "user";
    public static REQUEST_FORM_MODE_ADMIN = "admin";
    public static REQUEST_FORM_MODE_PM = "pm";
    public static REQUEST_FORM_MODE_SPONSORED = "sponsored";
    public static REQUEST_FORM_MODE_READ_ONLY = "readonly";

    public static REQUEST_FORM_MODE_PROJECT = "project";
    public static REQUEST_FORM_TITLE_PROJECT_LIST = "Project List";
    public static REQUEST_FORM_MODE_RESTRICTED_PROJECT = "project/restricted";


    public static PROJECT_IT_LEAD_ROLE = 'IT Lead';
    public static PROJECT_MANAGER_ROLE = 'Project Manager';


    public static FEEDBACK_FORM_MODE_ENTRY = "Entry";
    public static FEEDBACK_FORM_MODE_VIEW = "View";
    public static FEEDBACK_FORM_MODE_ADMIN = "admin";
    
    public static FEEDBACK_REQUESTS : string[] = [
        this.REQUEST_TYPE_CONSULTATION,
        this.REQUEST_TYPE_WORK_ORDER
    ]


    //beware, the code has not been fixed to be flexible for this value change to be the only change.
    public static MAX_COMPARE_ROWS = 3;


    //This must match value put in API. since the API doesn't return an error if trying to get more rows than MAX
    public static MAX_API_ROWS_RETREIVAL = 50000;

    public static MAX_ROW_RETREIVAL_WARNING = 50000;

    public static MAX_EXCEL_EXPORT_ROW_WARNING = 50000;

    public static MAX_EXPORT_ROW_WARNING = 100000;

    public static GRAPH_TOKEN_HEADER = 'Gtoken';


    public static RETURN_RESPONSE_MSG = 'Enterprise Technology will aim to respond within 2 business days.';
    public static OVERDUE_RESPONSE_HOURS = 48;
    


}